import React from 'react';
import { CheckCircle2, Truck } from 'lucide-react';
export function EBTWICBanner() {
  return <div className="bg-gradient-to-r from-[#1e3a8a] to-[#1e40af] text-white py-2 md:py-3 overflow-hidden" data-id="element-33">
      <div className="md:hidden" data-id="element-34">
        <div className="animate-marquee whitespace-nowrap flex items-center gap-6" data-id="element-35">
          <div className="flex items-center gap-1.5 bg-white/10 px-2.5 py-1 rounded-full" data-id="element-36">
            <CheckCircle2 className="w-3.5 h-3.5 text-[#93c5fd] flex-shrink-0" data-id="element-37" />
            <span className="text-xs font-bold" data-id="element-38">EBT/SNAP Accepted</span>
          </div>
          <div className="flex items-center gap-1.5 bg-[#ff6b35] text-white px-2.5 py-1 rounded-full" data-id="element-39">
            <CheckCircle2 className="w-3.5 h-3.5 flex-shrink-0" data-id="element-40" />
            <span className="text-xs font-bold" data-id="element-41">Free Delivery $35+</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-42">
            <Truck className="w-3.5 h-3.5 text-[#93c5fd] flex-shrink-0" data-id="element-43" />
            <span className="text-xs font-semibold" data-id="element-44">
              Uber Eats • DoorDash • Instacart • GrubHub
            </span>
          </div>
          <div className="flex items-center gap-1.5 bg-white/10 px-2.5 py-1 rounded-full" data-id="element-45">
            <CheckCircle2 className="w-3.5 h-3.5 text-[#93c5fd] flex-shrink-0" data-id="element-46" />
            <span className="text-xs font-bold" data-id="element-47">EBT/SNAP Accepted</span>
          </div>
          <div className="flex items-center gap-1.5 bg-[#ff6b35] text-white px-2.5 py-1 rounded-full" data-id="element-48">
            <CheckCircle2 className="w-3.5 h-3.5 flex-shrink-0" data-id="element-49" />
            <span className="text-xs font-bold" data-id="element-50">Free Delivery $35+</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-51">
            <Truck className="w-3.5 h-3.5 text-[#93c5fd] flex-shrink-0" data-id="element-52" />
            <span className="text-xs font-semibold" data-id="element-53">
              Uber Eats • DoorDash • Instacart • GrubHub
            </span>
          </div>
        </div>
      </div>
      <div className="hidden md:block max-w-7xl mx-auto px-6" data-id="element-54">
        <div className="flex items-center justify-center gap-6 lg:gap-8 flex-wrap" data-id="element-55">
          <div className="flex items-center gap-2" data-id="element-56">
            <CheckCircle2 className="w-5 h-5 text-[#93c5fd]" data-id="element-57" />
            <span className="text-sm font-semibold" data-id="element-58">WIC Approved</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-59">
            <CheckCircle2 className="w-5 h-5 text-[#93c5fd]" data-id="element-60" />
            <span className="text-sm font-semibold" data-id="element-61">EBT/SNAP</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-62">
            <CheckCircle2 className="w-5 h-5 text-[#93c5fd]" data-id="element-63" />
            <span className="text-sm font-semibold" data-id="element-64">USDA Partner</span>
          </div>
          <div className="flex items-center gap-2 bg-[#ff6b35] text-white px-3 py-1.5 rounded-full" data-id="element-65">
            <CheckCircle2 className="w-5 h-5" data-id="element-66" />
            <span className="text-sm font-bold" data-id="element-67">Free Delivery Over $35</span>
          </div>
          <div className="h-4 w-px bg-white/20" data-id="element-68" />
          <div className="flex items-center gap-3" data-id="element-69">
            <Truck className="w-5 h-5 text-[#93c5fd]" data-id="element-70" />
            <span className="text-sm font-semibold" data-id="element-71">Available on:</span>
            <div className="flex items-center gap-2 text-xs font-medium" data-id="element-72">
              <span className="bg-white/10 px-2 py-1 rounded" data-id="element-73">Uber Eats</span>
              <span className="bg-white/10 px-2 py-1 rounded" data-id="element-74">DoorDash</span>
              <span className="bg-white/10 px-2 py-1 rounded" data-id="element-75">Instacart</span>
              <span className="bg-white/10 px-2 py-1 rounded" data-id="element-76">GrubHub</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}